// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme, Box, Button, FormControl, InputLabel, Select, MenuItem, Autocomplete, TextField, Tabs, Tab } from "@mui/material";
import { default as dayjs } from "dayjs";
import {
  GridColDef,
  GridActionsCellItem,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { DeleteConfirmModal, Table } from "../../molecules";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import { Loading, StatusBar, StatusBarUser } from "../../atoms";
import {
  useAuthorization,
  useGetMerchantStatusList,
  IProduct,
  useGetProducts,
  useDeleteProduct,
  DeleteProductRequest,
  useGetProductGroups,
  useUpdateProduct
} from "../../../hooks";
import { useNavigate, useLocation } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { PagingResponse } from "../../../hooks/_types";
import { downloadExcel } from "../../../util/downloadExcel";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";
import { useUserInfo } from "../../../store/User.state";


function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;
  return <>{value && <StatusBarUser status={value} />}</>;
}

function RenderCurrency(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  const renderMoney = (money: string) => {
    switch (money) {
      case "949":
        return "TL";
      case "840":
        return "USD";
      case "978":
        return "EUR";
      default:
        return "-";
    }
  };

  return <>{renderMoney(value)}</>;
}

export const ProductsComponent = () => {
  const theme = useTheme();
  const [userInfo] = useUserInfo();
  const { showAdd, showDelete, showUpdate } = useAuthorization();
  const location = useLocation();

  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<IProduct>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const navigate = useNavigate();
  const { mutate: getProducts, isLoading } = useGetProducts();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const setSnackbar = useSetSnackBar();
  const { mutate: productDelete, isLoading: isDeleteLoading } = useDeleteProduct();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
    useGetMerchantStatusList({});
  const { data: productGroupsData, isLoading: isProductGroupsLoading } = useGetProductGroups({
    status: "ACTIVE",
    size: 100,
    page: 0,
  });
  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
  const [showTable, setShowTable] = useState(false);

  const [selectedProductGroup, setSelectedProductGroup] = useState(0);
  const [currentTab, setCurrentTab] = useState("ACTIVE");
  const { mutate: updateProduct, isLoading: isUpdateLoading } = useUpdateProduct();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
    setPaginationModel({ page: 0, pageSize: 25 }); // Reset pagination on tab change
    setTableData(undefined); // Clear table data
  };

  useEffect(() => {
    const savedFilter = localStorage.getItem("productFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  // AddProduct'tan döndüğünde refresh tetikleme
  useEffect(() => {
    if (location.state?.refresh) {
      setShouldRefresh(true);
      // State'i temizle
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state?.refresh, navigate, location.pathname]);


  const merchantStatuses = useMemo(() => {
    return rawMerchantStatus?.data?.map(
      (merchantStat: { value: string; key: number }) => {
        return {
          label: merchantStat?.key,
          value: `${merchantStat?.value}`,
        };
      }
    );
  }, [rawMerchantStatus?.data]);

  const productGroups = useMemo(() => {
    return productGroupsData?.data?.result?.map(
      (productGroup: { name: string; id: number }) => {
        return {
          label: productGroup.name,
          value: productGroup.id,
        };
      }
    );
  }, [productGroupsData?.data]);

  useEffect(() => {
    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: currentTab,
      groupId: selectedProductGroup,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getProducts(requestPayload, {
      onSuccess: (data) => {
        if (data?.isSuccess) {
          setTableData(data?.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setTableData(data?.data);
          setSnackbar({
            severity: "error",
            description: data?.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
    setShouldRefresh(false);
  }, [
    getProducts,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    currentTab,
    selectedProductGroup
  ]);


  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    getProducts(
      {
        size: model.pageSize,
        page: model.page,
        orderBy: "CreateDate",
        orderByDesc: true,
        status: currentTab,
        groupId: selectedProductGroup,
        ...getQueryParams(queryOptions),
      },
      {
        onSuccess: (data) => {
          if (data?.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const editRow = React.useCallback(
    (product: IProduct) => () => {
      navigate(`/product/${product.id}`);
    },
    [navigate]
  );

  const deleteRow = React.useCallback(
    (product: IProduct) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(product.id));
    },
    []
  );

  const [isUpdateStatusModalOpen, setIsUpdateStatusModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<IProduct | null>(null);
  const [targetStatus, setTargetStatus] = useState<'ACTIVE' | 'PASSIVE' | null>(null);

  const handleStatusChange = React.useCallback(
    (product: IProduct, status: 'ACTIVE' | 'PASSIVE') => () => {
      setIsUpdateStatusModalOpen(true);
      setSelectedProduct(product);
      setTargetStatus(status);
    },
    []
  );

  const handleChangeStatusConfirm = () => {
    if (!selectedProduct || !targetStatus) return;

    const request: IProduct = {
      ...selectedProduct,
      status: targetStatus
    };

    updateProduct(request, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh((prevState) => !prevState);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        }
        else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseStatusChangeModal();
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleCloseStatusChangeModal = () => {
    setIsUpdateStatusModalOpen(false);
    setSelectedProduct(null);
    setTargetStatus(null);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteProductRequest = { id: selectedRowId, status: 'DELETED' };

    productDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh((prevState) => !prevState);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };
  const columns: GridColDef<IProduct, any, any>[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          const actions = [];
          if (currentTab === 'ACTIVE') {
            if (showUpdate) {
              actions.push(
                <GridActionsCellItem
                  label="Düzenle"
                  onClick={editRow(params.row)}
                  showInMenu
                />
              );
            }
            actions.push(
              <GridActionsCellItem
                label="Pasife Al"
                onClick={handleStatusChange(params.row, 'PASSIVE')}
                showInMenu
              />
            );
            if (showDelete) {
              actions.push(
                <GridActionsCellItem
                  label="Sil"
                  onClick={deleteRow(params.row)}
                  showInMenu
                />
              );
            }
          } else { // PASSIVE tab
            actions.push(
              <GridActionsCellItem
                label="Aktif Et"
                onClick={handleStatusChange(params.row, 'ACTIVE')}
                showInMenu
              />
            );
            if (showDelete) {
              actions.push(
                <GridActionsCellItem
                  label="Sil"
                  onClick={deleteRow(params.row)}
                  showInMenu
                />
              );
            }
          }
          return actions;
        },

      },
      { field: "productCode", headerName: "Ürün Kodu", width: 150 },
      { field: "productName", headerName: "Ürün Adı", width: 250 },
      { field: "productGroupName", headerName: "Ürün Grup", width: 130 },
      { field: "productUnitName", headerName: "Birim Adı", width: 130 },
      { field: "salePrice", headerName: "Satış Fiyatı", width: 120, type: 'decimalOnly' },
      {
        field: "currencyCode",
        headerName: "Para Birimi",
        width: 120,
        renderCell: RenderCurrency
      },
      { field: "taxRateId", headerName: "Vergi Oranı ID", width: 130 },
      {
        field: "isOpenPrice",
        headerName: "Açık Fiyat",
        width: 120,
        renderCell: (params) => { return params.value ? "Evet" : "Hayır" }
      },
      { field: "barcode", headerName: "Barkod", width: 150 },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "Durum",
        width: 100,
        filterOperators: [createStatusOperator(merchantStatuses)],
      },
      { field: "createDate", headerName: "Oluşturma T.", width: 200, renderCell: (params) => { return dayjs(params.value).format("DD.MM.YYYY HH:mm") } },
      { field: "updateDate", headerName: "Güncelleme T.", width: 200, renderCell: (params) => { return params.value ? dayjs(params.value)?.format("DD.MM.YYYY HH:mm") : "" } },
    ];
  }, [deleteRow, editRow, showDelete, showUpdate, currentTab, handleStatusChange]);
  const keyMapping = {
    status: "Durum",
  };
  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      status: currentTab,
      groupId: selectedProductGroup,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getProducts(requestPayload, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          const renderMoney = (money: string) => {
            switch (money) {
              case "949":
                return "TL";
              case "840":
                return "USD";
              case "978":
                return "EUR";
              default:
                return "-";
            }
          };

          function fieldValue(data) {
            return data?.map((item) => {
              return {
                "Ürün Kodu": item?.productCode,
                "Ürün Adı": item?.productName,
                "Ürün Grup ID": item?.productGroupId,
                "Satış Fiyatı": item?.salePrice,
                "Vergi Oranı ID": item?.taxRateId,
                "Birim": item?.unit,
                "Açık Fiyat": item?.isOpenPrice ? "Evet" : "Hayır",
                "Barkod": item?.barcode,
                "Para Birimi": renderMoney(item?.currencyCode),
                [keyMapping["status"]]: item?.status,
                "Oluşturma Tarihi": item?.createDate,
                "Güncelleme Tarihi": item?.updateDate,
              };
            });
          }
          const refactoredData = fieldValue(data?.data?.result);
          downloadExcel(refactoredData || [], "Ürün Listesi", keyMapping);
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem("productFilter");
      return setQueryOptions({});
    }
    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem("productFilter", JSON.stringify(queryParams));
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);

  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;



  const hasLoading = isLoading || isDeleteLoading;

  return (
    <>
      {hasLoading && <Loading />}
      <Stack flex={1} p={2}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={currentTab} onChange={handleTabChange} aria-label="product status tabs">
            <Tab label="Aktif Ürünler" value="ACTIVE" />
            <Tab label="Pasif Ürünler" value="PASSIVE" />
          </Tabs>
        </Box>
        <BaseFilterTableWithAccordion
          summary="Filtreler"
          isExpanded={isFilterAccordionExpanded}
          setExpanded={setFilterAccordionExpand}
          setTableVisibility={setShowTable}
          child={
            <Stack spacing={2}>
              <FormControl sx={{ minWidth: 240 }}>
                <Autocomplete
                  id="product-group-select"
                  options={productGroups || []}
                  getOptionLabel={(option) => option.label}
                  value={productGroups?.find((g) => g.value === selectedProductGroup) || null}
                  onChange={(_, newValue) => {
                    setSelectedProductGroup(newValue ? newValue.value : 0);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Ürün Grubu" />
                  )}
                />
              </FormControl>
              <Button
                variant="contained"
                sx={{ width: 100, float: "right", alignSelf: "end" }}
                onClick={() => {
                  setShouldRefresh(prev => !prev);
                  setFilterAccordionExpand(false);
                  setShowTable(true);
                }}
              >
                Ara
              </Button>
            </Stack>
          }
        />
        {showTable && (
          <Stack mt={2}>
            <Table
              filterKey="productFilter"
              columnVisibilityConfigKey="productColumnVisibilityKey"
              hasActiveFilters={hasActiveFilters}
              handleFilterChange={handleFilterChange}
              paginationModel={paginationModel}
              onPaginationModelChange={handleChangePagination}
              paginationMode="server"
              rowCount={tableData?.totalItems || 0}
              sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
              isRowSelectable={() => false}
              // disableColumnMenu
              rows={tableData?.result || []}
              columns={columns}
              exportFileName="Ürün Listesi"
              onSave={() => onSave()}
            />
            <DeleteConfirmModal
              isOpen={isDeleteModalOpen}
              onClose={handleCloseDeleteModal}
              onConfirm={() => handleDeleteConfirm()}
            ></DeleteConfirmModal>
            <DeleteConfirmModal
              isOpen={isUpdateStatusModalOpen}
              onClose={handleCloseStatusChangeModal}
              onConfirm={() => handleChangeStatusConfirm()}
              title={`${targetStatus === 'ACTIVE' ? 'Aktif' : 'Pasif'} Etme Onayı`}
              content={`Seçili ürünü ${targetStatus === 'ACTIVE' ? 'aktif' : 'pasif'} etmek istiyor musunuz?`}
              confirmButtonText={`${targetStatus === 'ACTIVE' ? 'Aktif' : 'Pasif'} Et`}
              closeButtonText="Vazgeç"
            ></DeleteConfirmModal>
          </Stack>
        )}
      </Stack>
    </>
  );
};
